import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../../actions";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    PinterestShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    EmailShareButton,
    InstapaperShareButton,

    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    PinterestIcon,
    TelegramIcon,
    WhatsappIcon,
    EmailIcon,
    InstapaperIcon,
} from 'react-share';

class SocialShareModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: ""
        }
    }

    modalClose = () => {
        this.props.modalClose();
    }

    shareCountHandler = () => {
        if(this.props.data.countCall == undefined && this.props.data.countCall != false) {
            const mediaId = this.props.data.mediaId;
            const token = localStorage.getItem("token");
            const contestName = this.props.data.contestName != undefined ? this.props.data.contestName : this.props.data.ID;
            const userId = this.props.data.userId;
            this.props.shareCount({mediaId,token,contestName,userId, e: this.props.data.e});
        }
    }

    render() {

        let { shareLink, title,contestName } = this.props.data;
        let mediaLink = `https://res.cloudinary.com/contestee/image/upload/c_scale/v1/${this.props.data.media}`
        return (
            <div className="modal" id="ticketmodal" tabIndex="-1" role="dialog" aria-hidden="true" style={this.props.open ? { display: 'block' } : {}} onClick={this.modalClose}>
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    {
                        <div className="modal-content animated bounceIn" onClick={e => e.stopPropagation()}>
                            <div className="share-modal">
                                <React.Fragment>
                                    <div className="ticketcontent">
                                        <p className="mb-0 cotmed">Tap on button to share</p>
                                    </div>
                                    <div className="modalmaincontent">
                                        {shareLink != "" && shareLink != undefined ? (
                                            <div className="sharemodal">
                                                <div className="shareIconDiv" onClick={() => this.shareCountHandler()}>
                                                    <FacebookShareButton
                                                        url={shareLink}
                                                        quote={title}
                                                        className="shareIconDiv__share-button">
                                                        <FacebookIcon
                                                            size={40}
                                                            round />
                                                    </FacebookShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <TwitterShareButton
                                                        url={shareLink}
                                                        title={title}
                                                        className="shareIconDiv__share-button">
                                                        <TwitterIcon
                                                            size={40}
                                                            round />
                                                    </TwitterShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <TelegramShareButton
                                                        url={shareLink}
                                                        title={title}
                                                        className="shareIconDiv__share-button">
                                                        <TelegramIcon size={40} round />
                                                    </TelegramShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <WhatsappShareButton
                                                        url={shareLink}
                                                        title={title}
                                                        separator=":: "
                                                        className="shareIconDiv__share-button">
                                                        <WhatsappIcon size={40} round />
                                                    </WhatsappShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <LinkedinShareButton
                                                        url={shareLink}
                                                        windowWidth={750}
                                                        windowHeight={600}
                                                        className="shareIconDiv__share-button">
                                                        <LinkedinIcon
                                                            size={40}
                                                            round />
                                                    </LinkedinShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <PinterestShareButton
                                                        url={shareLink}
                                                        media={mediaLink}
                                                        windowWidth={1000}
                                                        windowHeight={730}
                                                        className="shareIconDiv__share-button">
                                                        <PinterestIcon size={40} round />
                                                    </PinterestShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <EmailShareButton
                                                        url={shareLink}
                                                        subject={title}
                                                        body="body"
                                                        className="shareIconDiv__share-button">
                                                        <EmailIcon
                                                            size={40}
                                                            round />
                                                    </EmailShareButton>
                                                </div>

                                                <div className="shareIconDiv"  onClick={() => this.shareCountHandler()}>
                                                    <InstapaperShareButton
                                                        url={shareLink}
                                                        title={title}
                                                        className="shareIconDiv__share-button">
                                                        <InstapaperIcon
                                                            size={40}
                                                            round />
                                                    </InstapaperShareButton>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ socialShareModal }) => {
    const { open, data } = socialShareModal;
    return { open, data };
};

const mapDispatchToProps = dispatch => ({
    modalClose: () => dispatch(actions.socialShareModalClose()),
    showAppLoader: () => dispatch(actions.showAppLoader()),
    shareCount: (payload) => dispatch(actions.shareCount(payload)) 
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SocialShareModal);